export const Theme = {
    // link
    link: (isActive: boolean) =>
        `${Theme.linkBase} ${Theme.linkHoverClass} ${
            Theme.linkActiveClass(isActive)
        }`,

    linkBase:
        "block w-full my-1 flex items-center justify-start gap-2 text-left text-sm p-2 rounded",
    linkHoverClass: "hover:bg-blue-50 dark:hover:bg-gray-700",
    linkActiveClass: (isActive: boolean) =>
        isActive
            ? "bg-blue-100 dark:bg-gray-700 text-blue-600 dark:text-blue-400"
            : "text-gray-600 dark:text-white",

    greyBorder: "border border-gray-200 dark:border-gray-700 rounded-2xl",

    label: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400",
    input:
        "dark:bg-dark-900 h-11 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-blue-600 focus:outline-hidden focus:ring-1 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800",
    textarea:
        "dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-blue-600 focus:outline-hidden focus:ring-1 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 dark:focus:border-brand-800",
};
